import { useEffect } from "react";
import { useApiInfoContextValueHook } from "../../../../contexts/ApiInfoContext";
import { useQueryParamsHook } from "../../../../utils/useQueryParamsHook";
import { useFetcher } from "./useFetcher";
import { useReturnExchangesValueContextHook } from "../contexts/ReturnExchangesContext";
import { ProductOptionsApi } from "../../../../apis/ProductOptionsApi";
import { SellertoolSignatureUtils } from "../../../../utils/sellertool-signature-utils";
import { useProductOptionsActionsContextHook } from "../contexts/ProductOptionsContext";
import { CommerceApiApi } from "../../../../apis/CommerceApiApi";
import { CoupangApiApi } from "../../../../apis/CoupangApiApi";
import { useStoreInfosActionsContextHook } from "../contexts/StoreInfosContext";

export function FetcherComponent(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const queryParamsHook = useQueryParamsHook();

    const returnExchangesValueContextHook = useReturnExchangesValueContextHook();
    const returnExchanges = returnExchangesValueContextHook?.returnExchanges || [];

    const productOptionsActionsContext = useProductOptionsActionsContextHook();

    const storeInfosActionsContext = useStoreInfosActionsContextHook();

    const optionCodes = returnExchanges?.reduce((acc, cur) => {
        if (cur.releaseOptionCode && !acc.includes(cur.releaseOptionCode)) {
            acc.push(cur.releaseOptionCode);
        }

        if (cur.collectionOptionCode && !acc.includes(cur.collectionOptionCode)) {
            acc.push(cur.collectionOptionCode);
        }

        if (cur.exchangeReleaseOptionCode && !acc.includes(cur.exchangeReleaseOptionCode)) {
            acc.push(cur.exchangeReleaseOptionCode);
        }
        return acc;
    }, []);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        fetcher.fetchReturnExchanges();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
        queryParamsHook?.params?.page,
        queryParamsHook?.params?.pageSize,
        queryParamsHook?.params?.searchCondition,
        queryParamsHook?.params?.searchQuery,
        queryParamsHook?.params?.startDate,
        queryParamsHook?.params?.endDate,
        queryParamsHook?.params?.archiveId,
        queryParamsHook?.params?.returnExchangeType,
        queryParamsHook?.params?.returnExchangeProceedStatuses,
    ]);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        fetcher.fetchReturnExchangeArchives();
        handleFetchStoreInfos();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
    ]);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey || optionCodes.length === 0) {
            return;
        }

        handleFetchProductOptions();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
        JSON.stringify(optionCodes)
    ]);

    const handleFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            optionCodes: optionCodes
        }
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: body
        })

        if (response?.content) {
            productOptionsActionsContext.productOptions.onSet(response?.content);
        }
    }

    const handleFetchStoreInfos = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        let storeInfos = [];

        const commerceApiStoreInfosResponse = await CommerceApiApi().searchCommerceApiStoreInfos({
            headers: headers
        })
        const coupangApiStoreInfosResponse = await CoupangApiApi().searchCoupangApiStoreInfos({
            headers: headers
        })

        if (commerceApiStoreInfosResponse?.content) {
            commerceApiStoreInfosResponse?.content?.forEach(storeInfo => {
                storeInfos.push({
                    id: storeInfo.id,
                    storeName: storeInfo.storeName,
                    storeType: 'COMMERCE_API'
                })
            })
        }

        if (coupangApiStoreInfosResponse?.content) {
            coupangApiStoreInfosResponse?.content?.forEach(storeInfo => {
                storeInfos.push({
                    id: storeInfo.id,
                    storeName: storeInfo.storeName,
                    storeType: 'COUPANG_API'
                })
            })
        }

        storeInfosActionsContext.storeInfos.onSet(storeInfos);
    }

    return (
        <>

        </>
    );
}